/**
 * @module services/dashboard
 * @description Servicio HTTP para el dashboard home de obra social
 */
import api from "./api";

export default {
  /** @returns {Promise<{ metrics, recentAuthorizations, recentActivity }>} */
  get: () => api.get("/dashboard").then((r) => r.data),
};
